import Searches from "./Searches";
import {SearchesProvider} from "../../context/searches/SearchesState";

export default function () {
    return (
        <SearchesProvider>
            <Searches />
        </SearchesProvider>
    )
}